import React from 'react';
import { Link } from 'react-router-dom';

function Lgpd() {
  return (
    <div className="container text-light mt-5 px-3">
      <div
        className="p-4 rounded-4 shadow-lg"
        style={{
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          backdropFilter: 'blur(8px)',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}
      >
        <h2 className="mb-3 text-white text-center">
          <i className="bi bi-person-badge me-2 text-warning"></i>
          LGPD e Conformidade
        </h2>

        <p className="text-white-50 text-center">
          A <strong>InfoService</strong> oferece soluções integradas para adequação à Lei Geral de Proteção de Dados (LGPD),
          ajudando sua empresa a cumprir com responsabilidade as normas de segurança, transparência e governança de dados.
        </p>

        <ul className="mt-4 fs-6">
          <li className="mb-3">
            <i className="bi bi-shield-lock-fill me-2 text-primary"></i>
            <strong>Mapeamento de dados:</strong> Identificação e classificação de dados pessoais, sensíveis e críticos, com rastreamento de fluxos internos.
          </li>

          <li className="mb-3">
            <i className="bi bi-file-earmark-text-fill me-2 text-success"></i>
            <strong>Revisão documental:</strong> Atualização de contratos, termos de uso, políticas de privacidade e compliance jurídico.
          </li>

          <li className="mb-3">
            <i className="bi bi-check-circle-fill me-2 text-info"></i>
            <strong>Plano de ação:</strong> Implementação de controles técnicos e administrativos para mitigação de riscos e conformidade.
          </li>

          <li className="mb-3">
            <i className="bi bi-people-fill me-2 text-warning"></i>
            <strong>Capacitação:</strong> Treinamentos corporativos sobre boas práticas de proteção de dados e responsabilidades legais.
          </li>

          <li className="mb-3">
            <i className="bi bi-lock-fill me-2 text-danger"></i>
            <strong>Segurança da informação:</strong> Adoção de políticas de acesso, criptografia, backups e auditorias para proteger a integridade dos dados.
          </li>
        </ul>

        <div className="mt-4 text-center">
          <Link to="/contato" className="btn btn-outline-warning btn-lg px-4">
            <i className="bi bi-envelope-fill me-2"></i>
            Fale com um especialista
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Lgpd;
